import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {TranslateLoader} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { BUILD_INFO } from '../../../environments/build-info';

export function customTranslateLoaderFactory(http: HttpClient): CustomTranslateHttpLoader {
  return new CustomTranslateHttpLoader(http);
}

@Injectable(
  {
    providedIn: 'root'
  }
)
export class CustomTranslateHttpLoader extends TranslateLoader
{
  constructor(private http: HttpClient)
  {
    super();
  }

  getTranslation(lang: string): Observable<any>
  {
    return this.http
      .get(`./assets/i18n/${lang}.json?v=${BUILD_INFO.pipeline}`)
      .pipe(map(translations => this.removeEmptyTranslations(translations)));
  }

  private removeEmptyTranslations(obj: any): any
  {
    for (const key in obj)
    {
      if (obj[key] === '')
        delete obj[key];
      else if (typeof obj[key] === 'object')
        this.removeEmptyTranslations(obj[key]);
    }
    return obj;
  }
}
